import { React, ui } from "aaa";
import { ConfirmationDialog } from "../common/ConfirmationDialog";

export const AliasDeleteUsernameConfirmationDialog = (props: {
    show: boolean,
    onClose: (deleteUsername?: boolean) => void,
}): any => {
    return (
        <ConfirmationDialog
            show={props.show}
            onClose={props.onClose}
            title={ui.__("sidentitySettings.deleteUsername.confirm.title")}
            message={ui.__("sidentitySettings.deleteUsername.confirm.message")}
            labelOk={ui.__("common.delete")}
        />
    );
};



// WEBPACK FOOTER //
// ./src/components/alias/AliasDeleteUsernameConfirmationDialog.tsx